// from https://github.com/kvz/locutus/blob/master/src/php/strings/str_replace.js
import { ensureString } from './lodash_replacements';

export function str_replace(search, replace, subject, countObj?) {
  let i = 0;
  let j = 0;
  let temp = '';
  let repl = '';
  let sl = 0;
  let fl = 0;
  const f = [].concat(search);
  let r = [].concat(replace);
  let s = subject;
  let ra = Object.prototype.toString.call(r) === '[object Array]';
  const sa = Object.prototype.toString.call(s) === '[object Array]';
  s = [].concat(s);

  const $global: any = typeof window !== 'undefined' ? window : global;
  $global.$locutus = $global.$locutus || {};
  const $locutus = $global.$locutus;
  $locutus.php = $locutus.php || {};

  if (typeof search === 'object' && typeof replace === 'string') {
    temp = replace;
    replace = [];
    for (i = 0; i < search.length; i += 1) {
      replace[i] = temp;
    }
    temp = '';
    r = [].concat(replace);
    ra = Object.prototype.toString.call(r) === '[object Array]';
  }

  if (typeof countObj !== 'undefined') {
    countObj.value = 0;
  }

  for (i = 0, sl = s.length; i < sl; i++) {
    if (s[i] === '') {
      continue;
    }
    for (j = 0, fl = f.length; j < fl; j++) {
      temp = `${s[i]}`;
      repl = ra ? (r[j] !== undefined ? r[j] : '') : r[0];
      s[i] = temp.split(f[j]).join(repl);
      if (typeof countObj !== 'undefined') {
        countObj.value += temp.split(f[j]).length - 1;
      }
    }
  }
  return sa ? s : s[0];
}

export function isNumericString(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function cleanStringToAlphanumericAndSpace(s: string = '') {
  let s2: string = s;
  if (typeof s !== 'string') s2 = ensureString(s);
  return (s2.toLowerCase() as any).replaceAll('[^\u00C0-\u017Fa-zA-Z 0-9]', ''); // \u00C0-\u017F: umlaute
}

export const ALPHABETH = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export function helper_isValidEmail(email): boolean {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function escapeHtml(unsafe) {
  return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}
